import { ListItemIcon, ListItemText, MenuItem } from "@material-ui/core";
import { isBoolean } from "lodash";
import { useState } from "react";
import { Confirm, useNotify } from "react-admin";
import { useAxiosInstance } from "../../../common/hooks/useAxiosInstance";
import {
  FleetManagerApiFactory,
  FleetManagerListDto,
} from "../../../common/data/service-proxies";

interface Props {
  label: string;
  icon: JSX.Element;
  record?: FleetManagerListDto;
  resource?: string;
  confirmTitle?: string;
  confirmContent?: string;
  onClick?: (event: React.MouseEvent) => void;
  onSuccess?: () => void;
  hidden?: boolean | ((record: FleetManagerListDto) => boolean);
}

export const ResetFleetManagerPasswordMenuItem = ({
  record,
  hidden,
  label,
  icon,
  onClick,
  onSuccess,
  ...rest
}: Props) => {
  const [isConfirmOpen, setConfirmOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const axios = useAxiosInstance();
  const notify = useNotify();

  if (!record?.id) {
    return null;
  }

  if (isBoolean(hidden)) {
    if (hidden) {
      return null;
    }
  } else {
    if (hidden && hidden(record)) {
      return null;
    }
  }

  const handleDialogClose = () => {
    setConfirmOpen(false);
  };

  const handleSend = () => {
    if (!axios) {
      return;
    }

    if (record.autoProvisioned) {
      setConfirmOpen(false);
      notify(
        `Unable to reset the password for this fleet manager because it is managed by '${record.autoProvisionProvider}'`,
        { type: "error" }
      );
      return;
    }

    setLoading(true);
    FleetManagerApiFactory(undefined, axios.defaults.baseURL, axios)
      .apiAppFleetmanagerIdRequestresetpasswordlinkforfleetmanagerPost(
        record.id!
      )
      .then(() => {
        notify(
          "resources.admin-fleet-managers.notifications.passwordResetSuccess",
          { type: "success" }
        );

        if (onSuccess) {
          onSuccess();
        }
      })
      .catch((e) => console.error(e))
      .finally(() => {
        setLoading(false);
        setConfirmOpen(false);
      });
  };

  return (
    <>
      <MenuItem
        {...rest}
        className="actions-menu-item"
        onClick={(e) => {
          setConfirmOpen(true);
          if (typeof onClick === "function") {
            onClick(e);
          }
        }}
      >
        <ListItemIcon>{icon}</ListItemIcon>
        <ListItemText>{label}</ListItemText>
      </MenuItem>
      <Confirm
        isOpen={isConfirmOpen}
        loading={loading}
        title="Confirm to reset password"
        content={`Are you sure you want to send the reset password link to '${record.fleetManagerName}'?`}
        onConfirm={handleSend}
        onClose={handleDialogClose}
      />
    </>
  );
};
